import { useBreakpoint } from "@seneca/senekit";

import { ChildrenType } from "seneca-common/features/parents/features/parent/service/hooks/types";

import {
  getChildName,
  getChildNameLimitOnDevice
} from "features/parents/utils/getChildName";

type UseGetSelectedChildNameParams = {
  selectedChild: ChildrenType | undefined;
  shouldDisplayFullName?: boolean;
};

export default function useGetSelectedChildName({
  selectedChild,
  shouldDisplayFullName = false
}: UseGetSelectedChildNameParams) {
  const { isMobileOnly } = useBreakpoint();

  const limit = getChildNameLimitOnDevice(isMobileOnly);
  const selectedChildName = getChildName({
    child: selectedChild,
    limit,
    shouldDisplayFullName
  });

  return selectedChildName;
}
